import actions from './actions';
import types from './mutation-types';

const state = {
	list: {
		error: null,
		isFetching: false,
		data: []
	}
};

const getters = {
	categoryList: state => state.list.data,
	listIsFetching: state => state.list.isFetching
};

const mutations = {
	[types.FETCH_LIST_START](state) {
		state.list.isFetching = true;
	},
	[types.FETCH_LIST_ERROR](state, error) {
		state.list.isFetching = false;
		state.list.error = error;
	},
	[types.FETCH_LIST_SUCCESS](state, data) {
		state.list.isFetching = false;
		state.list.error = null;
		state.list.data = data;
	}
};

export default {
	namespaced: true,
	state,
	actions,
	getters,
	mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/category-list/index.js